"use client";

import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function EventGallery() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const eventImages = [{
    id: 1,
    image: "https://first-ladybird.10web.cloud/wp-content/uploads/2026/02/IMG-048d6fc8726e50a604d3805236f36d99-V.webp?v=4ab2dd1v38x",
    alt: "Събитие с гости в Миш-Маш"
  }, {
    id: 2,
    image: "https://first-ladybird.10web.cloud/wp-content/uploads/2026/02/IMG-6ce3c7fc10e2caa4da36f325072c2724-V.webp?v=b7leflzz5",
    alt: "Богата трапеза на събитие"
  }, {
    id: 3,
    image: "https://first-ladybird.10web.cloud/wp-content/uploads/2026/02/IMG-91fc20efaab3289aa9c45c2745b7bbca-V.webp?v=66l5botd9p",
    alt: "Групово хранене в заведението"
  }, {
    id: 4,
    image: "https://first-ladybird.10web.cloud/wp-content/uploads/2026/02/IMG-fc99adaa8f7e3ccab639ea641fc59ff4-V.webp?v=5odnjao2exw",
    alt: "Рожден ден в Миш-Маш"
  }, {
    id: 5,
    image: "https://first-ladybird.10web.cloud/wp-content/uploads/2026/02/IMG-d20776159488780bf121e28e31704065-V.webp?v=t1vnw2ymnno",
    alt: "Фирмено събитие"
  }, {
    id: 6,
    image: "https://first-ladybird.10web.cloud/wp-content/uploads/2026/02/IMG-0147514a8efc2fafe02a54fdd04df7d4-V.webp?v=e01gbmxdk",
    alt: "Частно парти в заведението"
  }];
  return <section id="eventgallery" className="py-16 md:py-24 bg-background">
      <div className="container">
        <div ref={ref} className={`transition-all duration-500 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
          <div className="text-center mb-12">
            <h2 className="text-foreground mb-4">Галерия от Събития</h2>
            <p className="text-muted-foreground max-w-2xl mx-auto">Разгледайте помещението и моменти от минали събития в Миш-Маш /интерпред/. Създаваме незабравими преживявания за всеки празник или фирмено събитие.</p>
          </div>

          <div className="relative px-4 sm:px-6 md:px-12">
            <Carousel opts={{
            align: "start",
            loop: true
          }} className="w-full">
              <CarouselContent>
                {eventImages.map((item, i) => <CarouselItem key={item.id} data-index={i} className="md:basis-1/2 lg:basis-1/3">
                    <div className="p-1 sm:p-2">
                      <div className="relative overflow-hidden rounded-lg shadow-soft hover-lift group">
                        <img src={item.image} alt={item.alt} className="w-full object-contain transition-transform duration-500 group-hover:scale-105" />
                        <div className="surface-overlay" />
                      </div>
                    </div>
                  </CarouselItem>)}
              </CarouselContent>
              <CarouselPrevious className="bg-background hover:bg-accent hover:text-accent-foreground border-border shadow-medium" />
              <CarouselNext className="bg-background hover:bg-accent hover:text-accent-foreground border-border shadow-medium" />
            </Carousel>
          </div>
        </div>
      </div>
    </section>;
}